(() => {
  const carouselControllers = new Map();
  let galleryDialog = null;
  let galleryOpener = null;

  const pageRoot = () => document.querySelector('main.ms-factory-main');

  function getGalleryDialog() {
    if (galleryDialog) return galleryDialog;
    galleryDialog = document.createElement('dialog');
    galleryDialog.className = 'ms-factory-gallery';
    galleryDialog.setAttribute('aria-label', 'Enlarged factory photograph');
    galleryDialog.innerHTML = '<button type="button" data-factory-gallery-close aria-label="Close enlarged image">×</button><img alt=""><p></p>';
    pageRoot().append(galleryDialog);
    galleryDialog.addEventListener('close', () => {
      const opener = galleryOpener;
      galleryOpener = null;
      if (opener?.isConnected) opener.focus();
    });
    galleryDialog.querySelector('[data-factory-gallery-close]').addEventListener('click', () => galleryDialog.close());
    return galleryDialog;
  }

  function onPageClick(event) {
    const root = pageRoot();
    if (!root) return;
    const trigger = event.target.closest('main.ms-factory-main [data-gallery]');
    if (trigger) {
      const dialog = getGalleryDialog();
      const image = dialog.querySelector('img');
      const caption = trigger.dataset.caption || trigger.querySelector('img')?.alt || '';
      galleryOpener = trigger;
      image.src = trigger.dataset.gallery;
      image.alt = caption;
      dialog.querySelector('p').textContent = caption;
      dialog.showModal();
      return;
    }
    if (event.target.closest('[data-factory-gallery-close]') && galleryDialog?.open) galleryDialog.close();
  }

  function setupCarousel(track) {
    if (carouselControllers.has(track)) return;
    const root = track.closest('[data-oem-reference]');
    if (!root) return;

    const controller = new AbortController();
    const { signal } = controller;
    const originalControls = [...root.querySelectorAll('[data-oem-prev],[data-oem-next],[data-oem-pause]')];
    originalControls.forEach((button) => { button.hidden = true; });
    track.tabIndex = 0;
    track.dataset.msFactoryCarousel = 'true';

    const controls = document.createElement('div');
    controls.className = 'ms-factory-carousel-controls';
    controls.innerHTML = '<span class="ms-factory-carousel-status" aria-live="polite"></span><button type="button" aria-label="Previous process stages">←</button><button type="button" aria-label="Next process stages">→</button>';
    track.insertAdjacentElement('afterend', controls);
    const status = controls.querySelector('.ms-factory-carousel-status');
    const [previous, next] = controls.querySelectorAll('button');

    const stepSize = () => {
      const first = track.firstElementChild;
      if (!first) return track.clientWidth;
      return first.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
    };
    const sync = () => {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      controls.hidden = max < 2;
      previous.disabled = track.scrollLeft < 2;
      next.disabled = track.scrollLeft >= max - 2;
      status.textContent = `${Math.round(track.scrollLeft / Math.max(1, stepSize())) + 1} / ${Math.max(1, Math.ceil(max / Math.max(1, stepSize())) + 1)}`;
    };
    const move = (direction) => {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      const left = Math.max(0, Math.min(max, track.scrollLeft + direction * stepSize()));
      track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'auto' });
    };

    previous.addEventListener('click', () => move(-1), { signal });
    next.addEventListener('click', () => move(1), { signal });
    track.addEventListener('scroll', sync, { passive: true, signal });
    track.addEventListener('keydown', (event) => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      move(event.key === 'ArrowLeft' ? -1 : 1);
    }, { signal });
    const observer = new ResizeObserver(sync);
    observer.observe(track);
    carouselControllers.set(track, {
      cleanup() {
        controller.abort();
        observer.disconnect();
        controls.remove();
        originalControls.forEach((button) => { button.hidden = false; });
        delete track.dataset.msFactoryCarousel;
      },
    });
    sync();
  }

  function setupCarousels(root) {
    if (!(root instanceof Element)) return;
    if (root.matches('[data-oem-slides]')) setupCarousel(root);
    root.querySelectorAll('[data-oem-slides]').forEach(setupCarousel);
  }

  function cleanupCarousels(root) {
    if (!(root instanceof Element)) return;
    const tracks = [];
    if (root.matches('[data-oem-slides]')) tracks.push(root);
    tracks.push(...root.querySelectorAll('[data-oem-slides]'));
    for (const track of tracks) {
      carouselControllers.get(track)?.cleanup();
      carouselControllers.delete(track);
    }
  }

  function setup() {
    const root = pageRoot();
    if (!root) return;
    document.removeEventListener('click', onPageClick);
    document.addEventListener('click', onPageClick);
    setupCarousels(root);
  }

  function onSectionLoad(event) {
    if (pageRoot()) setupCarousels(event.target);
  }

  function onSectionUnload(event) {
    cleanupCarousels(event.target);
  }

  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', onSectionUnload);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
})();
